import * as React from "react"
import { useState, useEffect, useContext } from "react"
import { AuthContext } from "./AuthContext"
import { fetchChats } from "../business_logic/messaging"
import { Chat } from "../business_logic/model"

interface ChatsContextProps {
  chats: Chat[]
  chatsWithMessages: Chat[]
}

export const ChatsContext = React.createContext<ChatsContextProps>({
  chats: [],
  chatsWithMessages: [],
})

export const ChatsProvider = ({ children }) => {
  const [chats, setChats] = useState([])
  const [chatsWithMessages, setChatsWithMessages] = useState([])
  const { user } = useContext(AuthContext)

  useEffect(() => {
    // The Linkedin API seems to take a second or so for the email to register in the database, so to prevent
    // an error throw I added those additional checks
    if (user && user.id) {
      return fetchChats(
        user,
        newChats => {
          setChats(newChats)
          setChatsWithMessages(newChats.filter(c => c.hasMessages))
        },
        console.log,
      )
    }
  }, [user])

  return (
    <ChatsContext.Provider value={{ chats, chatsWithMessages }}>{children}</ChatsContext.Provider>
  )
}
